import React, { FC } from 'react';
import { formatTime, getSimpleDateFormat, getUserName } from 'utils/functions';
import './styles.scss';
import { ReactComponent as RiderIcon } from 'assets/icons/motorbike.svg';
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg';
import { Dropdown } from '@cokitchen/cokitchen-components';
import { ReactComponent as MailIcon } from 'assets/icons/sms.svg';
import { ReactComponent as PhoneIcon } from 'assets/icons/call.svg';
import OnlineStatus from 'components/base/online-status';
import { ReactComponent as MenuIcon } from 'assets/icons/menu.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { ReactComponent as BlacklistRiderIcon } from 'assets/icons/blacklist-rider.svg';
import { ReactComponent as NoteIcon } from 'assets/icons/note.svg';
import { RiderType } from 'models/rider.model';
import CopyText from 'components/base/copy-text';
import { withDropdownList } from 'components/base/dropdown-list';
import { DropdownListType } from './rider-result-table';

type Props = {
  riders: RiderType[];
  onSelect: (option: DropdownListType, rider: RiderType) => void;
};

const listMenu = [
  {
    name: 'View Profile',
    icon: <NoteIcon />,
    key: 'view-profile'
  },
  {
    name: 'Blacklist rider',
    icon: <BlacklistRiderIcon />,
    key: 'blacklist'
  },
  {
    name: 'Delete Rider',
    icon: <TrashIcon />,
    key: 'delete',
    className: 'text-[#E60A2B]'
  }
];

const DropdownList = withDropdownList<DropdownListType>();

const RiderResultMobile: FC<Props> = ({ riders, onSelect }) => {
  return (
    <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-4'>
      {riders.map((rider) => (
        <div key={rider.id} className='cursor-pointer live-trip-card relative'>
          <div className='flex flex-col gap-2 px-4 pb-3 grow'>
            <div className='flex justify-between items-center'>
              <OnlineStatus small online={rider.online} />
              <span onClick={(e) => e.stopPropagation()}>
                <Dropdown
                  content={
                    <MenuIcon className='bg-[#FEF0F2] w-7 h-7 p-[7px] rounded-full cursor-pointer transition-all duration-200 hover:bg-red-3' />
                  }>
                  <DropdownList
                    list={listMenu}
                    onSelect={(option) => onSelect(option, rider)}
                    className='min-w-[200px]'
                  />
                </Dropdown>
              </span>
            </div>
            <div className='flex items-center gap-2'>
              <RiderIcon className='w-4 h-4' />
              <h4 className='font-medium  text-base text-gray-6'>{getUserName(rider)}</h4>
            </div>
            <div className='grow'>
              <div className='flex justify-start items-center mb-1'>
                <MailIcon />
                <p className='mx-3 text-sm text-[#858585]'>{rider.email}</p>
              </div>
              <div className='inline-flex justify-start items-center'>
                <PhoneIcon />
                <CopyText className='mx-3 text-sm text-[#858585]' text={rider.phone_number} />
              </div>
            </div>
          </div>
          <div className='border-t border-gray-border text-xs p-4 flex justify-center gap-2 items-center'>
            <ClockIcon />
            <div className='flex items-center gap-2'>{getSimpleDateFormat(rider.created_at)}</div>
            <div className='bg-gray-2 min-w-[8px] w-2 h-2 rounded-full'></div>
            {formatTime(rider.created_at)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RiderResultMobile;
